import React from 'react';

const HoneypotField = ({ value, onChange }) => {
  return (
    <input
      type="text"
      name="website"
      value={value}
      onChange={onChange}
      autoComplete="off"
      tabIndex={-1}
      aria-hidden="true"
      style={{
        position: 'absolute',
        left: '-9999px',
        width: '1px',
        height: '1px',
        opacity: 0,
        pointerEvents: 'none',
      }}
    />
  );
};

export default HoneypotField;
